import React, { useState } from 'react';
import NextImage from 'next/image';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';

export const RESPONSVE_SIZES_CARDS = `(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 33vw`;
export const RESPONSVE_SIZES_CARDS_SMALL = `(max-width: 600px) 50vw, (max-width: 1024px) 25vw, 15vw`;
export const RESPONSIVE_SIZES_FIGURE = `(max-width: 600px) 100vw, (max-width: 1024px) 100vw, 50vw`;

const HOST_PROTOCOL =
  process.env.NODE_ENV === 'production' ? 'https://' : 'http://';

const IMAGE_HOST = global.window ? window.location.hostname : '';

export function Image(props) {
  const { assetId, ...restProps } = props;
  return (
    <NextImage
      src={`${HOST_PROTOCOL}${process.env.API_IMAGE_HOST}/${props.pathPrefix}${props.assetId}`}
      {...restProps}
    />
  );
}

Image.defaultProps = {
  pathPrefix: 'ada-assets/',
};

Image.propTypes = {
  pathPrefix: PropTypes.string,
  assetId: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
  imgContainer: {
    width: '100%',
    '& > div': {
      position: 'unset !important',
    },
  },
  img: {
    maxHeight: 'calc(100vh - 150px) !important',
    objectFit: 'contain',
    width: '100% !important',
    position: 'relative !important',
    height: 'unset !important',
  },
}));

export function SizedImage(props) {
  const { className, ...restProps } = props;
  const classes = useStyles();
  return (
    <div className={cx(classes.imgContainer, className)}>
      <Image className={cx(classes.img)} layout="fill" {...restProps} />
    </div>
  );
}
